const { watch } = require('@js/util/breakpoints')

let swiperElement = document.querySelector('.event-section .swiper')

if (swiperElement) {
  // Toggle event section swiper based on breakpoint
  // Configuration through Swiper.js' 'breakpoints' options works initially
  // but does not consider when the breakpoint changes.
  watch('lg', active => {
    if (active) {
      swiperElement.swiper.mousewheel.enable()
    } else {
      swiperElement.swiper.mousewheel.disable()
    }
  })
}
